import React, { useContext } from "react";
import TimeContext from "../../context/TimeContext";

export interface EATextProps {
  before?: string;
  during?: string;
  after?: string;
  default: string;
}

export interface eventTimesProps {
  start: Date;
  end: Date;
}

const EventAwareText = ({ text }: { text: EATextProps }) => {
  const eventTimes: eventTimesProps = useContext(TimeContext); // What is correct way to type check this?

  const date = () => {
    const startDate = new Date(eventTimes.start).getTime();

    // To test after event, use code below
    // const todayDate = new Date().getTime() + 999999999999999;
    const todayDate = new Date().getTime();
    const endDate = new Date(eventTimes.end).getTime();

    function dateState() {
      if (todayDate < startDate) {
        return text.before || text.default;
      } else if (startDate <= todayDate && todayDate <= endDate) {
        return text.during || text.default;
      } else if (todayDate > endDate) {
        return text.after || text.default;
      } else {
        console.log(
          "error in event aware text object, unable to find correct time"
        );
        return text.default || "Default Button Text";
        return;
      }
    }
    return dateState();
  };

  return <>{date()}</>;
};

export default EventAwareText;
